import React from 'react';

import { is, validatePassword } from '../../utils';
import { useAppContext } from '../../hooks';

import Form from '../Form';
import FormField from '../FormField';
import FormFooter from '../FormFooter';
import AcceptTOSCheckbox from '../AcceptTOSCheckbox';
import PasswordCheck from '../PasswordCheck';

const initialValues = {
  password: '',
  terms_of_service_accepted: false,
};

function validate(values, termsOfServiceRequired) {
  const errors = {};
  const { isValid, ...validationErrors } = validatePassword(values.password);
  if (!isValid) {
    errors.password = validationErrors;
  }
  if (termsOfServiceRequired && !values.terms_of_service_accepted) {
    errors.terms_of_service_accepted = 'PLACEHOLDER';
  }
  return errors;
}
function SetPasswordForm() {
  const { config } = useAppContext();
  return (
    <Form
      initialValues={initialValues}
      validate={(values) => validate(values, config.terms_of_service_required)}
    >
      <FormField
        name="password"
        type="password"
        autoComplete="new-password"
        label={i18n.gettext('Password')}
      />
      <PasswordCheck fieldName="password" />
      {config.terms_of_service_required && (
        <AcceptTOSCheckbox
          name="terms_of_service_accepted"
          style={{ margin: '2rem 0' }}
        />
      )}
      <FormFooter submitButtonLabel={i18n.gettext('Set password')} />
    </Form>
  );
}

export default SetPasswordForm;
